import { useState } from "react";
import toast from "react-hot-toast";
import useApi from "../utils/useApi";
import apis from "../utils/apis";

const useImageUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const { callApi: uploadToS3 } = useApi();

  const uploadImage = async (file) => {
    setIsUploading(true);
    try {
      const presign = await uploadToS3({
        api: apis.presignImageUpload,
        body: {
          contentType: file.type || "",
          fileName: file.name || "image.jpg",
        },
      });

      const putRes = await fetch(presign.uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": presign.contentType },
        body: file,
      });

      if (!putRes.ok) {
        throw new Error("S3 upload failed");
      }

      return presign.imageUrl;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  const uploadMultipleImages = async (files, onProgressUpdate) => {
    setIsUploading(true);
    setUploadProgress(0);

    try {
      const uploadPromises = files.map(async (file, index) => {
        const imageUrl = await uploadImage(file);
        
        // Update progress
        const progress = Math.round(((index + 1) / files.length) * 100);
        setUploadProgress(progress);
        
        if (onProgressUpdate) {
          onProgressUpdate(progress);
        }
        
        return imageUrl;
      });

      const imageUrls = await Promise.all(uploadPromises);
      setIsUploading(false);
      setUploadProgress(100);
      return imageUrls;
    } catch (error) {
      setIsUploading(false);
      setUploadProgress(0);
      toast.error("Failed to upload images. Please try again.");
      throw error;
    }
  };

  return {
    uploadImage,
    uploadMultipleImages,
    isUploading,
    uploadProgress,
  };
};

export default useImageUpload;
